import { render, staticRenderFns } from "./TransportationForm.vue?vue&type=template&id=41ad69b5&"
import script from "./TransportationForm.vue?vue&type=script&lang=js&"
export * from "./TransportationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports